export default "__VITE_ASSET__pXO8YJ5H__"